// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__ed7f95f5403b7d8bd2df","cls2":"AuthorHeader-cls2__c18e2e64ad6448e5c5ed AuthorHeader-cls1__ed7f95f5403b7d8bd2df"};